// File: /src/components/Footer.js
import React from 'react';
import '../styles/Footer.css';
import { useAuth } from '../contexts/AuthContext';

const Footer = () => {
	const { isAuthenticated } = useAuth();

	if (!isAuthenticated) return null;

	return (
		<footer className="app-footer">
			<div className="footer-content">
				<p>&copy; 2025 LocaTime. Todos os direitos reservados.</p>
			</div>
		</footer>
	);
};

export default Footer;
